export interface FacilitySettings {
  _id?: string;
  facilityImportId: string;
  facilityId: number;
  ownerActive: boolean;
  reportsActive: boolean;
  referralActive: boolean;
  assistedLiving: boolean;
  ehrNames: Record<string, string>;
  displayName: string;
  advancedDirectiveFileName?: string;
  approvedAdmissionFacilityId?: string;
  advancedDirectiveModel?: string;
  advancedDirectiveEnabled?: boolean;
}

export interface FacilitySettingsExtended extends FacilitySettings {
  facility_code: string;
  prov: string;
  name: string;
  regionId: number;
}

export interface FacilitySettingsColumnConfig {
  label: string;
  key: string;
  template: string;
}
